<template>
  <section class="banner-wrap three-column-banner">
    <div class="row justify-content-center">
      <div class="featured-categories-header">
        <div class="featured-categories-text">
          <h1 class="title">{{ data.title }}</h1>
          <br />
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-sm-18 col-md-6 text-center" v-if="data.banners.banner_1.image.path">
          <a
            :href="data.banners.banner_1.call_to_action_url"
            class="banner"
            :target="data.banners.banner_1.open_in_new_window ? '_blank' : '_self'"
          >
            <img
              :src="data.banners.banner_1.image.path"
              alt="banner"
              class="img-thumbnail rounded" style='max-width:400px'

            />
          </a>
        </div>

        <div class="col-sm-18 col-md-6 text-center" v-if="data.banners.banner_2.image.path">
          <a
            :href="data.banners.banner_2.call_to_action_url"
            class="banner"
            :target="data.banners.banner_2.open_in_new_window ? '_blank' : '_self'"
          >
            <img
              :src="data.banners.banner_2.image.path"
              alt="banner"
              class="img-thumbnail rounded" style='max-width:400px'
            />
          </a>
        </div>

        <div class="col-sm-18 col-md-6 text-center" v-if="data.banners.banner_3.image.path">
          <a
            :href="data.banners.banner_3.call_to_action_url"
            class="banner"
            :target="data.banners.banner_3.open_in_new_window ? '_blank' : '_self'"
          >
            <img
              :src="data.banners.banner_3.image.path"
              alt="banner"
              class="img-thumbnail rounded" style='max-width:400px'
            />
          </a>
        </div>
        <div class="col-sm-18 col-md-6 text-center" v-if="data.banners.banner_4.image.path">
          <a
            :href="data.banners.banner_4.call_to_action_url"
            class="banner"
            :target="data.banners.banner_4.open_in_new_window ? '_blank' : '_self'"
          >
            <img
              :src="data.banners.banner_4.image.path"
              alt="banner"
              class="img-thumbnail rounded" style='max-width:400px'
            />
          </a>
        </div>
        <div class="col-sm-18 col-md-6 text-center" v-if="data.banners.banner_5.image.path">
          <a
            :href="data.banners.banner_5.call_to_action_url"
            class="banner"
            :target="data.banners.banner_5.open_in_new_window ? '_blank' : '_self'"
          >
            <img
              :src="data.banners.banner_5.image.path"
              alt="banner"
              class="img-thumbnail rounded" style='max-width:400px'
            />
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: ["data"],
};
</script>
